import React from 'react'
import styled from '@emotion/styled'
import { mediaQueries } from '../../theme'
import { getLoginUrl } from '../../utils/auth'
import Button from '../shared/button'

const Content = styled.div`
  padding: ${p => `${p.theme.space[12]} ${p.theme.space[6]}`};
  text-align: center;
  ${mediaQueries.sm} {
    padding: ${p => `${p.theme.space[15]} ${p.theme.space[17]}`};
  }
`

const Icon = styled.div`
  font-size: ${p => p.theme.fontSizes[9]};
  margin-bottom: ${p => p.theme.space[4]};
`

const Title = styled.h1`
  font-size: ${p => p.theme.fontSizes[5]};
  text-align: center;
  margin: ${p => `0 0 ${p.theme.space[3]} 0`};
  ${mediaQueries.sm} {
    font-size: ${p => p.theme.fontSizes[7]};
  }
`

const Subtitle = styled.p`
  font-size: ${p => p.theme.fontSizes[1]};
  color: ${p => p.theme.colors.gray[6]};
  margin: ${p => `0 0 ${p.theme.space[8]} 0`};
`

const LoginButton = styled(Button)`
  padding: ${p => `${p.theme.space[4]} ${p.theme.space[8]}`};
  font-size: ${p => p.theme.fontSizes[4]};
  background-color: ${p => p.theme.colors.black[0]};
  color: ${p => p.theme.colors.white};
  border-radius: ${p => p.theme.space[2]};

  ${mediaQueries.lg} {
    font-size: ${p => p.theme.fontSizes[2]};
    min-height: 3rem;
    min-width: 6.875rem;
    padding: ${p => `${p.theme.space[2]} ${p.theme.space[5]}`};
  }
`

const SignupsClosed = ({ className, next }) => {
  const loginUrl = getLoginUrl(next)

  return (
    <Content className={className}>
      <Icon role="img" aria-label="Locked">
        🔒
      </Icon>
      <Title>New signups are currently closed</Title>
      <Subtitle>Stay tuned for updates.</Subtitle>
      <LoginButton as="a" href={loginUrl}>
        Log in
      </LoginButton>
    </Content>
  )
}

export default SignupsClosed
